import { User, UserCredentials } from '@backend/domain'
import { Injectable } from '@nestjs/common'
import { InjectRepository } from '@nestjs/typeorm'
import { Repository } from 'typeorm'
import { BaseEntityRepository, SoftDeleteEntityRepository } from './generic'

@Injectable()
export class UserRepository extends SoftDeleteEntityRepository<User> {
	constructor(@InjectRepository(User) override readonly _repository: Repository<User>) {
		super(_repository)
	}
}

@Injectable()
export class UserCredentialsRepository extends BaseEntityRepository<UserCredentials> {
	constructor(@InjectRepository(UserCredentials) override readonly _repository: Repository<UserCredentials>) {
		super(_repository)
	}
}
